import { FormInstance } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";
import dayjs from "dayjs";

// 默认查询数据
export const DEFAULT_QUERY_DATA = {
    BankName: '',
    BankNo: '',
    DateStart: '',
    DateEnd: '',
    MemberEmail: '',
    OrderNo: '',
};

// 默认分页数据
export const DEFAULT_PAGE_DATA = {
    Page: 1,
    PageSize: 10,
    Total: 0,
};

// 生成查询表单配置
export const generateQueryFormConfig = (): FormConfigType => {
    return [
        {
            title: "银行名称",
            field: "BankName",
            type: "input",
            placeholder: "请输入银行名称",
        },
        {
            title: "银行卡号",
            field: "BankNo",
            type: "input",
            placeholder: "请输入银行卡号",
        },
        {
            title: "邮箱",
            field: "MemberEmail",
            type: "input",
            placeholder: "请输入会员邮箱",
        },
        {
            title: "订单号",
            field: "OrderNo",
            type: "input",
            placeholder: "请输入订单号",
        },
        {
            title: "开始时间",
            field: "DateStart",
            type: "datePicker",
            placeholder: "请选择开始时间",
        },
        {
            title: "结束时间",
            field: "DateEnd",
            type: "datePicker",
            placeholder: "请选择结束时间",
        },
    ];
};

// 生成表格列配置
export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "订单号",
            dataIndex: "OrderNo",
            key: "OrderNo",
        },
        {
            title: "会员邮箱",
            dataIndex: ["Member", "Email"],
            key: "MemberEmail",
        },
        {
            title: "银行名称",
            dataIndex: "BankName",
            key: "BankName",
        },
        {
            title: "银行卡号",
            dataIndex: "BankNo",
            key: "BankNo",
        },
        {
            title: "转账金额",
            key: "TransferAmount",
            render: (_: any, record: any) => (
                `${record.TransferAmount || '-'} ${record.BankAccountCurrencyCode || ''}`
            ),
        },
        {
            title: "实时汇率(USD)",
            dataIndex: "ExchangeRate",
            key: "ExchangeRate",
        },
        {
            title: "汇款汇率(USD)",
            dataIndex: "ApplyExchangeRate",
            key: "ApplyExchangeRate",
        },
        {
            title: "汇款通道/汇款时效",
            key: "ChannelAndTime",
            render: (_: any, record: any) => (
                `${record.ChannelName || '-'} / ${record.ChannelCreditedTimeName || '-'}`
            ),
        },
        {
            title: "状态",
            dataIndex: "Status",
            key: "Status",
            render: (text: number, record) => {
                // 根据实际业务定义状态映射
                const statusMap: Record<number, string> = {
                    10: "处理中",
                    20: "失败",
                    40: "成功",
                    5: "汇兑转换中",
                    6: "汇兑转换成功,等待汇款",
                };
                return statusMap[text] +
                    (record.UpstreamReason ? `:${record.UpstreamReason}` : '')
                    || "未知";
            }
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
            key: "CreatedAtString",
        },
    ];
};